import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var PlantSocialSci = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.645 42.898c-1.002-4.109-5.31-7.115-9.618-6.314-.4-2.605-2.504-4.71-5.11-5.21l1.704-5.312c12.022-4.71 15.528-13.128 8.515-24.351C32.834-.394 32.934-.294 30.63.608c-12.022 5.211-13.925 14.33-6.712 24.853l-1.403 4.61-3.506-3.408c.701-6.513-1.803-12.025-9.016-12.326-1.002-.1-2.004 0-2.605 0-.601.1-1.102 0-1.603.301-.4.501-.3 1.002-.4 1.603 0 .702-.1 1.604 0 2.606.3 7.416 6.01 9.82 12.422 9.019l3.406 3.407c-2.004.501-3.607 1.804-4.408 3.708-4.909-.2-9.116 3.307-10.118 7.816-.1.702.3 1.203.801 1.203h30.255c.601 0 1.002-.601.901-1.102ZM14.6 26.263c-5.51-.2-7.714-3.909-7.514-9.02l9.017 9.02c-.401.1-.902.1-1.503 0ZM8.49 16.14c6.01-.3 9.117 2.906 8.916 8.919L8.49 16.141ZM32.734 2.813c5.81 9.42 3.606 16.535-6.512 20.944l6.512-20.944ZM22.916 20.15c-4.007-8.618.2-14.33 8.115-17.838l-6.512 20.944c-.5-.802-1.102-1.804-1.603-3.106ZM8.69 42.196c1.203-3.307 4.508-5.712 8.215-5.411.501.1 1.102 0 1.303-.601 1.603-5.011 9.016-4.009 9.116 1.403 0 .3.1.6.4.801.201.2.502.2.802.1 3.206-1.102 6.813.702 8.115 3.708H8.69Z"
  }));
});
PlantSocialSci.displayName = 'PlantSocialSci';
PlantSocialSci.defaultProps = {
  'aria-label': 'PlantSocialSci'
};
export default PlantSocialSci;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/PlantSocialSci.js
// module id = 3692
// module chunks = 11